import { MOBILE_MODE } from '@constants/size';
import styled from '@emotion/styled';

type Props = {
  button1?: React.ReactNode;
  button2?: React.ReactNode;
};

const Layout = styled.div`
  display: flex;
  column-gap: 16px;
  justify-content: center;

  @media ${MOBILE_MODE} {
    max-width: 320px;
    row-gap: 8px;
    flex-direction: column-reverse;
  }
`;

export default function DefaultButtonBox({ button1, button2 }: Props) {
  return (
    <Layout>
      {button1}
      {button2}
    </Layout>
  );
}
